import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

const CAP_POSITIONS = ['left', 'top'];

const Card = ({
  stacked,
  children,
  className,
  url,
  useRouter,
  cap,
  onClick,
  mantleOverride,
  noHover,
}) => {
  const cardClassNames = classNames(
    'Card',
    {
      'Card--stacked': stacked,
      'Card--withLeftCap': cap && cap === CAP_POSITIONS[0],
      'Card--withTopCap': cap && cap === CAP_POSITIONS[1],
      'CustomColor--borderColor': cap && CAP_POSITIONS.includes(cap),
      'Card--mantleOverride': mantleOverride,
      'Card--mantleOverride--noHover': mantleOverride && noHover,
    },
    className,
  );

  const sharedProps = {
    className: cardClassNames,
    onClick,
  };

  if (url)
    return useRouter ? (
      <Link to={url} {...sharedProps}>
        {children}
      </Link>
    ) : (
      <a href={url} {...sharedProps}>
        {children}
      </a>
    );

  return <div {...sharedProps}>{children}</div>;
};

export default Card;
